module.exports = __webpack_public_path__ + "img/bought-dialog.7e572cb9.jpeg";